export default __webpack_public_path__ + "static/media/pic3.dad22356.jpg";